<template>
  <div class="files-pages">
    <div class="files-pages-filters">
      <div class="wrapper">
        <div class="custom-row">
          <div class="f-p-f-left">
            <div class="row-search">
              <input 
                type="text" 
                id="searchInput" 
                placeholder="Search files..." 
                v-model="searchQuery"
                @input="onSearchInput"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="files-page-content">
      <div class="custom-row">
        <div class="files-pg-sidebar">
          <ul>
            <li>
              <button 
                :class="{ active: currentFilter === 'all' }" 
                @click="setFilter('all')"
                id="allDocumentsButton"
              >
                {{ constants.ALL_DOCUMENTS_BUTTON }}
                <span>{{ fileCounts.all }}</span>
              </button>
            </li>
            <li>
              <button 
                :class="{ active: currentFilter === 'today' }" 
                @click="setFilter('today')"
                id="todayButton"
              >
                {{ constants.TODAY_BUTTON }}
                <span>{{ fileCounts.today }}</span>
              </button>
            </li>
            <li>
              <button 
                :class="{ active: currentFilter === 'yesterday' }" 
                @click="setFilter('yesterday')"
                id="yesterdayButton"
              >
                {{ constants.YESTERDAY_BUTTON }}
                <span>{{ fileCounts.yesterday }}</span>
              </button>
            </li>
            <li>
              <button 
                :class="{ active: currentFilter === 'lastWeek' }" 
                @click="setFilter('lastWeek')"
                id="lastWeekButton"
              >
                {{ constants.LAST_WEEK_AGO_BUTTON }}
                <span>{{ fileCounts.lastWeek }}</span>
              </button>
            </li>
            <li>
              <button 
                :class="{ active: currentFilter === 'lastMonth' }" 
                @click="setFilter('lastMonth')"
                id="lastMonthButton"
              >
                {{ constants.LAST_MONTH_AGO_BUTTON }}
                <span>{{ fileCounts.lastMonth }}</span>
              </button>
            </li>
            <li>
              <button 
                :class="{ active: currentFilter === 'custom' }" 
                @click="toggleCustomDate"
                id="customDateButton"
              >
                {{ constants.CUSTOM_DATE_BUTTON }}
                <div class="cale-icon">
                  <img src="@/assets/lems-v1/images/calendar-icon.svg" alt="" />
                </div>
              </button>
              <div :class="{'custom-date-box-show': showCustomDate}" class="custom-date-box">
                <div class="custom-date-box-in">
                  <div class="custom-date-box-date custom-date-box-start">
                    <label>Start Date:</label>
                    <input
                      type="date"
                      v-model="startDateString"
                      class="date-input"
                      :max="maxDate"
                      @change="onStartDateChange"
                      @click="onDateInputClick"
                    />
                  </div>
                  <div class="custom-date-box-date custom-date-box-end">
                    <label>End Date:</label>
                    <input
                      type="date"
                      v-model="endDateString"
                      class="date-input"
                      :max="maxDate"
                      @change="onEndDateChange"
                      @click="onDateInputClick"
                    />
                  </div>
                  <!-- <div class="custom-date-actions">
                    <button @click="applyCustomDate" class="apply-date-btn">Apply</button>
                    <button @click="clearCustomDate" class="clear-date-btn">Clear</button>
                  </div> -->
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="files-content-rigth">
          <!-- Loading State -->
          <div v-if="loading" class="loading-state">
            <p>Loading files...</p>
          </div>
          
          <!-- Error State -->
          <div v-if="error" class="error-state">
            <p style="color: red;">{{ error }}</p>
            <button @click="loadFiles" class="retry-btn">Retry</button>
          </div>
          
          <!-- Files List -->
          <div v-if="!loading && !error" class="files-list-section">
            <div class="files-list-hd">
              <ul>
                <li>
                  <strong>
                    {{ constants.NAME_TEXT }}
                  </strong>
                </li>
                <!-- <li>
                  <strong>
                    {{ constants.CHAT_ROOM_TEXT }}
                  </strong>
                </li> -->
                <li>
                  <strong>
                    {{ constants.SHARED_BY_TEXT }}
                  </strong>
                </li>
                <li>
                  <strong>
                    {{ constants.DATE_TIME_TEXT }}
                  </strong>
                </li>
                <li>
                  <strong>
                    {{ constants.SIZE_TEXT }}
                  </strong>
                </li>
                <li>
                  <strong>
                    {{ constants.ACTION_TEXT }}
                  </strong>
                </li>
              </ul>
            </div>
            <div class="files-list-btm">
              <!-- No files state -->
              <div v-if="sortedFiles.length === 0" class="no-files">
                <p>No files found</p>
              </div>
              
              <!-- Files List -->
              <div v-for="file in sortedFiles" :key="file.id" class="files-list-row">
                <ul>
                  <li>
                    <div class="files-d-b">
                      <!-- <i>
                        <img
                          :src="getFileIcon(file.file_icon)"
                          :alt="file.name"
                        />
                      </i> -->
                      <div class="files-d-b-span">
                        <strong>{{ file.name }}</strong>
                        <!-- <p>{{ file.is_folder ? 'Folder' : 'File' }}</p> -->
                      </div>
                    </div>
                  </li>
                  <!-- <li data-title="CHAT ROOM">
                    <a class="link" href="#" @click="openChat(file)">
                      {{ file.chat_room }}
                    </a>
                  </li> -->
                  <li data-title="SHARED BY">{{ file.shared_by }}</li>
                  <li data-title="DATE/TIME">{{ formatDate(file.last_modified) }}</li>
                  <li data-title="SIZE">
                    {{ file.formatted_size }}
                  </li>
                  <li data-title="ACTION">
                    <div class="action-dropdown">
                      <a
                        href="javascript:void(0);"
                        class="action-dots"
                        @click="toggleActionDropdown(file.id)"
                      >
                        <span></span>
                      </a>
                      <div class="action-dropdownbox" :class="{ show: activeDropdown === file.id }">
                        <div class="action-dropdownbox-in">
                          <a
                            class="download-icon"
                            href="javascript:void(0);"
                            @click="downloadFile(file)"
                          >
                            {{ constants.DOWNLOAD_LINK }}
                          </a>
                          <!-- <a
                            class="delete-icon"
                            href="javascript:void(0);"
                            @click="deleteFile(file)"
                          >
                            {{ constants.DELETE_LINK }}
                          </a> -->
                        </div>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          
          <!-- Pagination -->
          <div class="v1-pagination-box" v-if="totalPages > 1">
            <ul>
              <li
                class="pagination-first"
                v-if="currentPage !== 1"
                @click="changePage(currentPage - 1)"
              >
                <button id="paginationPreButton"></button>
              </li>
              <li
                v-for="page in visiblePages"
                :key="page"
                @click="changePage(page)"
                v-if="totalPages != 1"
              >
                <a href="#" :class="{ active: currentPage === page }">{{ page }}</a>
              </li>
              <li
                class="pagination-last"
                v-if="currentPage !== totalPages"
                @click="changePage(currentPage + 1)"
              >
                <button id="paginationNextButton"></button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import constants from "@/utils/en-US-Employee.json";
import axios from "axios";
import moment from "moment-timezone";
import { API_BASE_URL } from "@/config/api.config";

interface NextcloudFile {
  id: number;
  name: string;
  path: string;
  size: number;
  formatted_size: string;
  last_modified: string;
  formatted_date: string;
  content_type: string;
  is_folder: boolean;
  file_extension: string;
  file_icon: string;
  download_url: string;
  shared_by: string;
  chat_room: string;
  source?: string; // Track where the file came from (personal, shared, shared_with_me)
}

export default defineComponent({
  name: "EmployeeFiles",
  data() {
    return {
      constants,
      // Nextcloud files data
      files: [] as NextcloudFile[],
      loading: false,
      error: null as string | null,
      // Current user info
      currentUser: null as any,
      // Search and filters
      searchQuery: "",
      currentFilter: "all",
      // Custom date filtering
      showCustomDate: false,
      startDateString: "",
      endDateString: "",
      // Pagination
      currentPage: 1,
      totalPages: 1,
      itemsPerPage: 20,
      totalFiles: 0,
      // UI state
      activeDropdown: null as number | null,
      // API base URL
      apiBaseUrl: `${API_BASE_URL}/jira`,
      // File counts for sidebar
      fileCounts: {
        all: 0,
        today: 0,
        yesterday: 0,
        lastWeek: 0,
        lastMonth: 0
      },
      // Search timeout for debouncing
      searchTimeout: null as any
    };
  },
  computed: {
    visiblePages(): number[] {
      const pages = [];
      const start = Math.max(1, this.currentPage - 2);
      const end = Math.min(this.totalPages, this.currentPage + 2);
      
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },
    maxDate(): string {
      return new Date().toISOString().split('T')[0];
    },
    sortedFiles(): NextcloudFile[] {
      // Sort files by last_modified date in descending order (newest first)
      const sorted = [...this.files].sort((a, b) => {
        const dateA = new Date(a.last_modified);
        const dateB = new Date(b.last_modified);
        return dateB.getTime() - dateA.getTime(); // Descending order (newest first)
      });
      
      // Debug logging
      if (sorted.length > 0) {
        console.log("Sorted files (newest first):");
        sorted.slice(0, 3).forEach((file, index) => {
          console.log(`${index + 1}. ${file.name} - ${file.last_modified}`);
        });
      }
      
      return sorted;
    }
  },
  async mounted() {
    await this.initializeFiles();
    
    // Add click outside handler for custom date picker
    document.addEventListener('click', this.handleClickOutside);
  },
  
  beforeUnmount() {
    // Remove click outside handler
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    async initializeFiles() {
      try {
        // Check if user is logged in
        const isLoggedIn = localStorage.getItem("is_jira_loggedIn") === "true";
        const username = localStorage.getItem("jira_user_username");
        
        if (!isLoggedIn || !username) {
          this.error = "User not logged in";
          return;
        }
        
        // Create user object with username
        this.currentUser = {
          userName: username,
        };
        
        console.log("Initializing files for user:", this.currentUser);
        await this.loadFiles();
        // Load file counts for all filters
        await this.updateFileCounts();
      } catch (error) {
        console.error("Error initializing files:", error);
        this.error = "Failed to initialize files";
      }
    },

    async loadFiles() {
      if (!this.currentUser?.userName) {
        this.error = "User not found";
        return;
      }

      this.loading = true;
      this.error = null;

      try {
        const params: any = {
          limit: this.itemsPerPage,
          offset: (this.currentPage - 1) * this.itemsPerPage,
          search: this.searchQuery
        };

        // Add date filter
        if (this.currentFilter === 'today') {
          params.date_filter = 'today';
        } else if (this.currentFilter === 'yesterday') {
          params.date_filter = 'yesterday';
        } else if (this.currentFilter === 'lastWeek') {
          params.date_filter = 'last_week';
        } else if (this.currentFilter === 'lastMonth') {
          params.date_filter = 'last_month';
        } else if (this.currentFilter === 'custom') {
          if (this.startDateString) {
            params.start_date = this.startDateString;
          }
          if (this.endDateString) {
            params.end_date = this.endDateString;
          }
        }

        console.log("Making API call to:", `${this.apiBaseUrl}/nextcloud/files/${this.currentUser.userName}/`, "with params:", params);
        console.log("Current filter:", this.currentFilter);
        console.log("Current page:", this.currentPage);
        const response = await axios.get(
          `${this.apiBaseUrl}/nextcloud/files/${this.currentUser.userName}/`,
          { params }
        );

        console.log("API Response for files:", response.data);
        if (response.data.files) {
          this.files = response.data.files;
          this.totalFiles = response.data.total_files;
          this.totalPages = Math.ceil(this.totalFiles / this.itemsPerPage);
          
          console.log("Loaded files:", this.files.length);
          console.log("Files data:", this.files);
          
          // Update file counts after loading files
          await this.updateFileCounts();
          
          // Log first few files for debugging
          if (this.files.length > 0) {
            console.log("Sample file:", this.files[0]);
            console.log("Sample file download URL:", this.files[0].download_url);
          } else {
            console.log("No files found in response");
          }
        }
      } catch (error: any) {
        console.error("Error loading files:", error);
        console.error("Error response:", error.response?.data);
        this.error = error.response?.data?.error || "Failed to load files";
      } finally {
        this.loading = false;
      }
    },

    async updateFileCounts() {
      // Load file counts for each filter
      try {
        // Get counts for all filters
        const countPromises = [
          this.getFileCount('all'),
          this.getFileCount('today'),
          this.getFileCount('yesterday'),
          this.getFileCount('last_week'),
          this.getFileCount('last_month')
        ];
        
        const [allCount, todayCount, yesterdayCount, lastWeekCount, lastMonthCount] = await Promise.all(countPromises);
        
        this.fileCounts.all = allCount;
        this.fileCounts.today = todayCount;
        this.fileCounts.yesterday = yesterdayCount;
        this.fileCounts.lastWeek = lastWeekCount;
        this.fileCounts.lastMonth = lastMonthCount;
        
        console.log("Updated file counts:", this.fileCounts);
      } catch (error) {
        console.error("Error updating file counts:", error);
        // Fallback to current files if API fails
        this.fileCounts.all = this.totalFiles;
        this.fileCounts.today = this.files.filter(f => this.isToday(f.last_modified)).length;
        this.fileCounts.yesterday = this.files.filter(f => this.isYesterday(f.last_modified)).length;
        this.fileCounts.lastWeek = this.files.filter(f => this.isLastWeek(f.last_modified)).length;
        this.fileCounts.lastMonth = this.files.filter(f => this.isLastMonth(f.last_modified)).length;
      }
    },

    async getFileCount(filter: string): Promise<number> {
      if (!this.currentUser?.userName) return 0;
      
      try {
        const params: any = {
          limit: 1, // Just get count, not actual files
          offset: 0,
          search: this.searchQuery
        };

        // Add date filter
        if (filter === 'today') {
          params.date_filter = 'today';
        } else if (filter === 'yesterday') {
          params.date_filter = 'yesterday';
        } else if (filter === 'last_week') {
          params.date_filter = 'last_week';
        } else if (filter === 'last_month') {
          params.date_filter = 'last_month';
        }

        const response = await axios.get(
          `${this.apiBaseUrl}/nextcloud/files/${this.currentUser.userName}/`,
          { params }
        );

        return response.data.total_files || 0;
      } catch (error) {
        console.error(`Error getting file count for ${filter}:`, error);
        return 0;
      }
    },

    isToday(dateString: string): boolean {
      const today = new Date();
      const fileDate = new Date(dateString);
      return fileDate.toDateString() === today.toDateString();
    },

    isYesterday(dateString: string): boolean {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      const fileDate = new Date(dateString);
      return fileDate.toDateString() === yesterday.toDateString();
    },

    isLastWeek(dateString: string): boolean {
      const weekAgo = new Date();
      weekAgo.setDate(weekAgo.getDate() - 7);
      const fileDate = new Date(dateString);
      return fileDate >= weekAgo;
    },

    isLastMonth(dateString: string): boolean {
      const monthAgo = new Date();
      monthAgo.setMonth(monthAgo.getMonth() - 1);
      const fileDate = new Date(dateString);
      return fileDate >= monthAgo;
    },

    onSearchInput() {
      // Debounce search
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.currentPage = 1;
        this.loadFiles();
      }, 500);
    },

    setFilter(filter: string) {
      console.log("Setting filter to:", filter);
      this.currentFilter = filter;
      this.currentPage = 1;
      this.loadFiles();
    },

    changePage(page: number) {
      this.currentPage = page;
      this.loadFiles();
    },

    goToPage(page: number) {
      this.currentPage = page;
      this.loadFiles();
    },

    goToFirstPage() {
      this.currentPage = 1;
      this.loadFiles();
    },

    goToLastPage() {
      this.currentPage = this.totalPages;
      this.loadFiles();
    },

    toggleActionDropdown(fileId: number) {
      this.activeDropdown = this.activeDropdown === fileId ? null : fileId;
    },

    getFileIcon(iconType: string): string {
      const iconMap: { [key: string]: string } = {
        'folder': '@/assets/lems-v1/images/file-type/folder.svg',
        'pdf': '@/assets/lems-v1/images/file-type/pdf.svg',
        'word': '@/assets/lems-v1/images/file-type/word.svg',
        'excel': '@/assets/lems-v1/images/file-type/word.svg', // Using word icon for excel
        'powerpoint': '@/assets/lems-v1/images/file-type/ppt.svg',
        'image': '@/assets/lems-v1/images/file-type/image.svg',
        'video': '@/assets/lems-v1/images/file-type/video.svg',
        'archive': '@/assets/lems-v1/images/file-type/zip.svg',
        'text': '@/assets/lems-v1/images/file-type/word.svg', // Using word icon for text
        'file': '@/assets/lems-v1/images/file-type/word.svg' // Default file icon
      };
      
      return iconMap[iconType] || iconMap['file'];
    },

    downloadFile(file: NextcloudFile) {
      if (file.is_folder) {
        console.log("Cannot download folder:", file.name);
        alert("Cannot download folders. Please select individual files.");
        return;
      }
      
      console.log("Downloading file:", file.name, "URL:", file.download_url);
      
      try {
        // Create a temporary link to download the file
        const link = document.createElement('a');
        link.href = `${file.download_url}`;
        link.download = file.name;
        link.target = '_blank';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        
        console.log("Download initiated for:", file.name);
      } catch (error) {
        console.error("Error downloading file:", error);
        alert("Failed to download file. Please try again.");
      }
    },

    deleteFile(file: NextcloudFile) {
      if (confirm(`Are you sure you want to delete "${file.name}"?`)) {
        console.log("Deleting file:", file.name);
        // TODO: Implement file deletion API call
        this.loadFiles(); // Refresh the list
      }
    },

    openChat(file: NextcloudFile) {
      console.log("Opening chat for file:", file.name);
      // Navigate to the chat page
      this.$router.push('/employee/chats');
    },

    formatDate(date: any): string {
      if (!date) return 'Unknown';
      const nyDate = moment.utc(date).tz("America/New_York");
      return nyDate.format("MMM DD, YYYY h:mm A");
    },

    toggleCustomDate() {
      this.showCustomDate = !this.showCustomDate;
      console.log("Custom date picker toggled:", this.showCustomDate);
      if (!this.showCustomDate) {
        this.currentFilter = 'all';
        this.startDateString = "";
        this.endDateString = "";
        this.loadFiles();
      }
    },

    onStartDateChange() {
      console.log("Start date changed:", this.startDateString);
      this.checkAndApplyCustomFilter();
    },

    onEndDateChange() {
      console.log("End date changed:", this.endDateString);
      this.checkAndApplyCustomFilter();
    },

    checkAndApplyCustomFilter() {
      // Only apply filter if both dates are selected
      if (this.startDateString && this.endDateString) {
        console.log("Both dates selected, applying custom filter automatically");
        this.currentFilter = 'custom';
        this.currentPage = 1;
        this.loadFiles();
        this.showCustomDate = false; // Close the date picker after applying
      }
    },

    onDateInputClick(event: Event) {
      console.log("Date input clicked, opening calendar");
      // Force the date input to show the calendar
      const input = event.target as HTMLInputElement;
      input.showPicker && input.showPicker();
    },

    applyCustomDate() {
      if (this.startDateString || this.endDateString) {
        this.currentFilter = 'custom';
        this.currentPage = 1;
        this.loadFiles();
        this.showCustomDate = false;
        console.log("Applied custom date filter:", { 
          startDate: this.startDateString, 
          endDate: this.endDateString 
        });
      } else {
        alert("Please select at least one date (start or end date)");
      }
    },

    clearCustomDate() {
      this.startDateString = "";
      this.endDateString = "";
      this.currentFilter = 'all';
      this.showCustomDate = false;
      this.currentPage = 1;
      this.loadFiles();
      console.log("Cleared custom date filter");
    },

    handleClickOutside(event: Event) {
      const target = event.target as HTMLElement;
      const customDateBox = document.querySelector('.custom-date-box');
      const customDateButton = document.getElementById('customDateButton');
      
      if (this.showCustomDate && 
          customDateBox && 
          !customDateBox.contains(target) && 
          customDateButton && 
          !customDateButton.contains(target)) {
        this.showCustomDate = false;
      }
    }
  }
});
</script>

<!-- <style scoped>
/* Loading and Error States */
.loading-state, .error-state {
  padding: 20px;
  text-align: center;
}

.retry-btn {
  background: #007bff;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 10px;
}

.retry-btn:hover {
  background: #0056b3;
}

/* No files state */
.no-files {
  padding: 40px 20px;
  text-align: center;
  color: #666;
}

/* Active filter button */
.active {
  background-color: #e3f2fd !important;
  border-left: 3px solid #2196f3;
}

/* Action dropdown */
.action-dropdownbox.show {
  display: block;
}

.action-dropdownbox {
  display: none;
  position: absolute;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  z-index: 1000;
  min-width: 120px;
}

.action-dropdownbox-in {
  padding: 8px 0;
}

.action-dropdownbox-in a {
  display: block;
  padding: 8px 16px;
  color: #333;
  text-decoration: none;
  transition: background-color 0.2s;
}

.action-dropdownbox-in a:hover {
  background-color: #f5f5f5;
}

.download-icon {
  color: #28a745;
}

.delete-icon {
  color: #dc3545;
}

/* Pagination */
.pagination-first button:disabled,
.pagination-last button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* File icons */
.files-d-b img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

/* Search input */
#searchInput {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
}

#searchInput:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

/* Custom Date Filter */
.custom-date-box {
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  z-index: 1000;
  min-width: 300px;
  margin-top: 5px;
  display: none;
}

.custom-date-box-show {
  display: block !important;
}

.custom-date-box-in {
  padding: 15px;
}

.custom-date-box-date {
  margin-bottom: 10px;
}

.custom-date-box-date input {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  background: white;
  cursor: pointer;
  min-height: 40px;
}

.custom-date-box-date input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.custom-date-box-date input:hover {
  border-color: #007bff;
}

.custom-date-box-date label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #333;
  font-size: 14px;
}

.custom-date-actions {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.apply-date-btn, .clear-date-btn {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.apply-date-btn {
  background: #007bff;
  color: white;
}

.apply-date-btn:hover {
  background: #0056b3;
}

.clear-date-btn {
  background: #6c757d;
  color: white;
}

.clear-date-btn:hover {
  background: #545b62;
}
</style> -->
